import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "option",
        key: `view-${index}-${option.value}`
      }, [
        _createVNode(_component_q_btn, {
          onClick: ($event: any) => (_ctx.handleClick(option.value)),
          label: option.label,
          class: _normalizeClass({ 'active': _ctx.modelValue === option.value }),
          "no-wrap": "",
          flat: "",
          ripple: false,
          padding: "10px 12px"
        }, {
          default: _withCtx(() => [
            (_ctx.modelValue === option.value)
              ? (_openBlock(), _createBlock(_component_add_icon, {
                  key: 0,
                  left: ""
                }))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, option.value, { activeValue: _ctx.modelValue }, undefined, true)
          ]),
          _: 2
        }, 1032, ["onClick", "label", "class"])
      ]))
    }), 128))
  ]))
}